import httpClient from "./httpClient";

const TIPO_PRODUTO_ORDER = {
  NOVO: 0,
  PORT: 1,
  REFIN: 2,
};

function normalizeTipoProdutoLabel(value) {
  return String(value || "").trim().toUpperCase();
}

function normalizeBanco(raw = {}) {
  return {
    bancoId: String(raw.bancoId ?? raw.BancoId ?? raw.id ?? ""),
    bancoNome: raw.bancoNome ?? raw.BancoNome ?? raw.nome ?? "",
  };
}

function normalizeTipoConvenio(raw = {}) {
  const id = String(raw.id ?? raw.Id ?? raw.tipoConvenioId ?? raw.TipoConvenioId ?? "").trim();
  const nomeOriginal = String(raw.nome ?? raw.Nome ?? raw.descricao ?? raw.Descricao ?? "").trim();
  const codigo = normalizeTipoProdutoLabel(raw.codigo ?? raw.Codigo ?? raw.sigla ?? raw.Sigla ?? "");
  const fallbackCodigo = normalizeTipoProdutoLabel(nomeOriginal);
  const safeCodigo = codigo || fallbackCodigo || id;

  return {
    id,
    codigo: safeCodigo,
    nome: nomeOriginal || safeCodigo,
    ordem: TIPO_PRODUTO_ORDER[safeCodigo] ?? 999,
  };
}

function normalizeConvenio(raw = {}) {
  const tiposRaw = raw.tiposConvenio ?? raw.TiposConvenio ?? [];
  return {
    convenioId: String(raw.convenioId ?? raw.ConvenioId ?? raw.id ?? ""),
    convenioNome: raw.convenioNome ?? raw.ConvenioNome ?? raw.nome ?? "",
    convenioIdPai: String(raw.convenioIdPai ?? raw.ConvenioIdPai ?? ""),
    tiposConvenio: Array.isArray(tiposRaw) ? tiposRaw.map(normalizeTipoConvenio) : [],
  };
}

export async function listarBancosAtivos() {
  const response = await httpClient.get("/api/integracao/join/bancos-ativos");
  return Array.isArray(response.data) ? response.data.map(normalizeBanco) : [];
}

export async function listarConveniosAtivos() {
  const response = await httpClient.get("/api/integracao/join/convenios-ativos");
  return Array.isArray(response.data) ? response.data.map(normalizeConvenio) : [];
}

export async function buscarVidaVendedorResumo({
  vendedorId,
  dataInicio,
  dataFim,
  bancosIds,
  conveniosIds,
  tiposConvenio,
  tipoPeriodo,
}) {
  const response = await httpClient.post("/api/integracao/join/vida-vendedor-resumo", {
    vendedorId,
    dataInicio,
    dataFim,
    bancosIds: Array.isArray(bancosIds) ? bancosIds : [],
    conveniosIds: Array.isArray(conveniosIds) ? conveniosIds : [],
    tiposConvenio: Array.isArray(tiposConvenio) ? tiposConvenio : [],
    tipoPeriodo: tipoPeriodo || undefined,
  });
  return response.data?.payload || response.data || {};
}

export async function buscarVidaVendedorDetalhada({
  vendedorId,
  dataInicio,
  dataFim,
  bancosIds,
  conveniosIds,
  tiposConvenio,
  granularidadeEvolucao,
  tipoPeriodo,
}) {
  const response = await httpClient.post("/api/integracao/join/vida-vendedor-detalhada", {
    vendedorId,
    dataInicio,
    dataFim,
    bancosIds: Array.isArray(bancosIds) ? bancosIds : [],
    conveniosIds: Array.isArray(conveniosIds) ? conveniosIds : [],
    tiposConvenio: Array.isArray(tiposConvenio) ? tiposConvenio : [],
    granularidadeEvolucao: granularidadeEvolucao || undefined,
    tipoPeriodo: tipoPeriodo || undefined,
  });
  return response.data?.payload || response.data || {};
}
